import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import {
  DataSource,
  PROVIDERS,
  ProviderSource,
  SOURCE_ABBREVIATIONS,
  SourceRow,
  rowProviders,
} from '@app/model';
import { SourceDisplayService } from './source-display.service';

/**
 * The sources line in the head of the company page: the providers that
 * deliver the company, a legend of the badges and the switch "Show sources".
 */
@Component({
  selector: 'app-source-summary',
  templateUrl: './source-summary.component.html',
  styleUrls: [
    './source-badge.component.scss',
    './source-summary.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SourceSummaryComponent {
  public readonly display = inject(SourceDisplayService);

  @Input() row: SourceRow | null = null;

  public readonly abbreviations = SOURCE_ABBREVIATIONS;
  public readonly legend: DataSource[] = [
    ...PROVIDERS,
    'manual',
    'computed',
    'classified',
  ];

  get providers(): ProviderSource[] {
    return rowProviders(this.row);
  }

  toggle(event: Event) {
    this.display.setVisible((event.target as HTMLInputElement).checked);
  }
}
